import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-commerces',
  templateUrl: './commerces.component.html',
  styleUrls: ['./commerces.component.scss']
})
export class CommercesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
